import { motion } from "framer-motion";
import { ShoppingBag, Route, BadgePercent, Timer } from "lucide-react";

const FEATURES = [
    {
        icon: ShoppingBag,
        title: "Multi-Stop Bag",
        desc: "Order from multiple cafes in one go. One bag, every craving covered.",
    },
    {
        icon: Route,
        title: "Smart Pickup Sequence",
        desc: "Auto-routes your stops so every pickup is on the way, never out of it.",
    },
    {
        icon: BadgePercent,
        title: "Zero Platform Fee",
        desc: "Customers pay nothing extra. Menu price is the price, full stop.",
    },
    {
        icon: Timer,
        title: "3-Minute Pickup Guarantee",
        desc: "From walking in to walking out in three minutes. That's the deal.",
    },
];

export const Features = () => (
    <section className="border-t border-[#1f1f1f] bg-[#0d0d0d]" data-testid="features-section">
        <div className="mx-auto max-w-7xl px-6 py-20 md:py-32">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5 }}
            >
                <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary">Why Quikpik</p>
                <h2 className="mt-3 max-w-xl text-3xl font-extrabold tracking-tighter sm:text-4xl lg:text-5xl">
                    Built for people who <span className="text-primary">don't wait.</span>
                </h2>
            </motion.div>

            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2">
                {FEATURES.map((feature, i) => (
                    <motion.article
                        key={feature.title}
                        initial={{ opacity: 0, y: 28 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.5, delay: i * 0.1 }}
                        data-testid={`feature-card-${i + 1}`}
                        className="group flex items-start gap-6 rounded-2xl border border-[#2a2a2a] bg-[#161616] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-primary"
                    >
                        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-primary text-[#111111] transition-transform duration-200 group-hover:-rotate-6">
                            <feature.icon className="h-7 w-7" strokeWidth={2.25} />
                        </span>
                        <div>
                            <h3 className="text-xl font-bold tracking-tight">{feature.title}</h3>
                            <p className="mt-2 text-sm leading-relaxed text-[#a1a1aa] md:text-base">{feature.desc}</p>
                        </div>
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);
